import { useEffect, useState, useRef,useContext } from "react";
 
import { MasterConfigContext } from "@/context/MasterConfigContext";

const VodITGT = ({ content }) => {
  const masterConfigCT = useContext(MasterConfigContext);
  const eneable_pip = masterConfigCT?.vod_player_pip;
  const [playerReady, setPlayerReady] = useState(false);
  const [playerPluginReady, setPlayerPluginReady] = useState(false);
  const [isPipLoaded, setIsPipLoaded] = useState(true);
  const [pipManuallyClosed, setPipManuallyClosed] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const videoReadyRef = useRef(false);
  const observerRef = useRef(null);
  const fallbackTimerRef = useRef(null);
 const descriptionURL = encodeURIComponent(
    content?.permaLink || process.env.NEXT_PUBLIC_WEBSITE_URL,
  );
  const _ad_slots = {
    duration: 142,
    everyMidRole: 300,
    midLast: 60,
      preTag: `https://pubads.g.doubleclick.net/gampad/ads?iu=/1007232/News_Tak_VOD_Pre_Roll&description_url=${descriptionURL}&tfcd=0&npa=0&sz=400x300%7C640x480&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=`,
    midTag: `https://pubads.g.doubleclick.net/gampad/ads?iu=/1007232/News_Tak_VOD_Mid_roll&description_url=${descriptionURL}&tfcd=0&npa=0&sz=400x300%7C640x480&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=`,
    postTag: `https://pubads.g.doubleclick.net/gampad/ads?iu=/1007232/News_Tak_VOD_Post_roll&description_url=${descriptionURL}&tfcd=0&npa=0&sz=400x300%7C640x480&gdfp_req=1&unviewed_position_start=1&output=vast&env=vp&impl=s&correlator=`,
  };

  
  function jWPlayerConfig(is_ad_free) {
    var _hide_ads = 0;
    let noads = "0";
    if (noads == "1") {
      _hide_ads = 1;
    }
    return {
      config_url: "",
      content_id: content?.id,
      duration: "",
      videoContainer: "nwtakPlayerVOD",
      aspectratio: "16:9",
      vtt_file: "",
      file1: content?.assetFileLink,
      file2: "",
      pip: eneable_pip ,
      aps_slot: "aps_vod_at",
      title: content?.title,
      media_id: "vod_" + content?.id,
      ga_ref: "embed_video", // for embed video page for story embed video player.
      ga_ref: "video", // for inline vidoe player like lallantop.com/video/
      image: content?.headingImageUrl,
      sharing_link: content?.permaLink,
      hlslabels: {},
      source: "jwplayer",
      autostart: true,
      labelmapping: `c3="newstak", 
      ns_st_ci="${content.id}", 
      ns_st_cl="${content.durationInMs}", 
      ns_st_pu="Indiatoday Group", 
      ns_st_st="Indiatoday Group", 
      ns_st_ia="0", 
      ns_st_ge="${content.categoryName} newstak", 
      ns_st_ddt="${content.publishDate}", 
      ns_st_ce="1", 
      ns_st_tdt="${content.publishDate}", 
      ns_st_title="${content.title}", 
      ns_st_ep="${content.title}", 
      ns_st_pr="${content.title}"
    `.replace(/\s+/g, " "),
      publisherId: "8549097",
      advertising: {
        client: "googima",
        skipoffset: 30,
        midRollSchedule: _ad_slots,
      },
      noads: _hide_ads,
      ga: {},
      sharing_sites: ["facebook", "twitter", "email"],
      plugins: {
        "https://akm-img-a-in.tosshub.com/aajtak/resource/smedia2/lightsout.js":
          {},
      },
      repeat: false,
    };
  }


  // -------------------------
  // Add scripts & CSS
  // -------------------------
  useEffect(() => {
    addPlayerScripts();
  }, []);

  useEffect(() => {
    if (playerReady && playerPluginReady) runPlayer();
  }, [playerReady, playerPluginReady]);

  useEffect(() => {
    // load CSS
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =  "https://akm-img-a-in.tosshub.com/sites/player/media/vod-3-0/vod-min.css?v=03072025-02";
    document.head.appendChild(link);
    return () => {
      if (link && link.parentNode) link.parentNode.removeChild(link);
    };
  }, []);

  // Scroll PiP logic (unchanged)
  useEffect(() => {
    if (eneable_pip !== 1  ) return;
    const videoWrapper = document.querySelector("#vod_wrapper");
    const handleScroll = () => {
      if (pipManuallyClosed) return;
      const scrollY = window.scrollY;
      if (scrollY > 650) {
        videoWrapper?.classList.add("video-bottom-fixed");
      } else {
        videoWrapper?.classList.remove("video-bottom-fixed");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isPipLoaded, pipManuallyClosed]);

  // -------------------------
  // Run player and hook into actual <video> DOM events
  // -------------------------
  const runPlayer = () => {
    try {
      const playerDiv = document.getElementById("nwtakPlayerVOD");
      if (!playerDiv) {
        console.error("[runPlayer] Player container not found");
        return;
      }

      playerDiv.innerHTML = "";
      if (typeof ITGDPlayer !== "undefined") {
        // initialize player (ITGDPlayer likely injects video markup)
        
        new ITGDPlayer(window.jwConfig, "nwtakPlayerVOD");
        window.playerState = "PLAYING";
        
      } else {
        console.error("[runPlayer] ITGDPlayer is undefined");
      }

      // Start observing `#nwtakPlayerVOD` for a video element
      observeForVideoElement(playerDiv);
      // fallback: ensure loader hides eventually (avoid infinite loader)
      fallbackTimerRef.current = setTimeout(() => {
        if (!videoReadyRef.current) {
          console.warn("[runPlayer] Fallback: hiding loader after timeout");
          setIsVideoLoaded(true);
        }
      }, 10000); // 10s fallback
    } catch (err) {
      console.error("[runPlayer] Error:", err);
    }
  };

  const observeForVideoElement = (container) => {
    // If video already present, attach directly
    const existingVideo = container.querySelector("video");
    if (existingVideo) {
      attachVideoListeners(existingVideo);
      return;
    }

    // Otherwise use a MutationObserver to watch for added nodes
    if (observerRef.current) observerRef.current.disconnect();

    observerRef.current = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          // either the node itself is a video or contains a video
          const vid = node.tagName === "VIDEO" ? node : node.querySelector?.("video");
          if (vid) {
            attachVideoListeners(vid);
            // once we find it, no longer need the observer
            if (observerRef.current) {
              observerRef.current.disconnect();
              observerRef.current = null;
            }
            return;
          }
        }
      }
    });

    observerRef.current.observe(container, { childList: true, subtree: true });
  };

  const attachVideoListeners = (videoEl) => {
    if (!videoEl || videoReadyRef.current) return;
    videoReadyRef.current = true;

    const onLoadedData = () => {
      setIsVideoLoaded(true);
      cleanupVideoListeners();
    };
    const onCanPlay = () => {
      setIsVideoLoaded(true);
      cleanupVideoListeners();
    };
    const onPlaying = () => {
      setIsVideoLoaded(true);
      cleanupVideoListeners();
    };
    const onError = () => {
      setIsVideoLoaded(true);
      cleanupVideoListeners();
    };

    videoEl.addEventListener("loadeddata", onLoadedData, { once: true });
    videoEl.addEventListener("canplay", onCanPlay, { once: true });
    videoEl.addEventListener("playing", onPlaying, { once: true });
    videoEl.addEventListener("error", onError, { once: true });

    // In some cases autoplay is blocked — if the video is already paused but ready, can hide loader:
    if (videoEl.readyState >= 3 /* HAVE_FUTURE_DATA / canplay */) {
      setIsVideoLoaded(true);
      cleanupVideoListeners();
    }

    // store cleanup closure on element so we can remove later
    videoEl.__vod_cleanup = () => {
      try {
        videoEl.removeEventListener("loadeddata", onLoadedData);
        videoEl.removeEventListener("canplay", onCanPlay);
        videoEl.removeEventListener("playing", onPlaying);
        videoEl.removeEventListener("error", onError);
      } catch (e) {
        /* ignore */
      }
    };
  };

  const cleanupVideoListeners = () => {
    // Clear fallback timer
    if (fallbackTimerRef.current) {
      clearTimeout(fallbackTimerRef.current);
      fallbackTimerRef.current = null;
    }
    // remove any video listeners attached to the element(s)
    const container = document.getElementById("nwtakPlayerVOD");
    if (container) {
      const videos = container.querySelectorAll("video");
      videos.forEach((v) => {
        if (v.__vod_cleanup) {
          try {
            v.__vod_cleanup();
          } catch (e) {}
          delete v.__vod_cleanup;
        }
      });
    }
  };

  // cleanup on unmount
  useEffect(() => {
    return () => {
      if (observerRef.current) observerRef.current.disconnect();
      if (fallbackTimerRef.current) clearTimeout(fallbackTimerRef.current);
      cleanupVideoListeners();
    };
  }, []);

  // --- ADD PLAYER SCRIPTS ---
  const addPlayerScripts = () => {
    if (typeof window === "undefined") return;

    const jwConfig = jWPlayerConfig(true);
    window.jwConfig = jwConfig;

    const script = document.createElement("script");
    script.src =  "https://akm-img-a-in.tosshub.com/sites/player/media/vod-3-0/vod-min.js?v=03072025-02";
    script.onload = () => {
      setPlayerReady(true);
    };
    script.onerror = () => console.error("[addPlayerScripts] vod-alpha.js failed");
    document.head.appendChild(script);

    const pluginScript = document.createElement("script");
    pluginScript.src =
      "https://census-web.scorecardresearch.com/plugins/streaming-jwplayer/v2/current.js";
    pluginScript.onload = () => {
      setPlayerPluginReady(true);
    };
    pluginScript.onerror = () => console.error("[addPlayerScripts] plugin failed");
    document.head.appendChild(pluginScript);
  };

  // PiP close
  const handleClosePip = () => {
    const mainPlayer = document.querySelector("#vod_wrapper");
    if (mainPlayer) mainPlayer.classList.remove("video-bottom-fixed");
    setPipManuallyClosed(true);
    const scrollY = window.scrollY;
    window.scrollTo(0, scrollY);
    const closeBtn = document.getElementById("vod_close_btn");
    if (closeBtn) closeBtn.style.display = "none";
  };

  return (
    <div id="vod_wrapper" style={{ position: "relative" }}>
        

      <button id="vod_close_btn" onClick={handleClosePip}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11" fill="none" className="jw-svg-icon jw-svg-icon-floating-close" focusable="false">
          <path
            d="M7.41499 5.00001L10.705 1.70501C10.8688 1.51371 10.9544 1.26763 10.9447 1.01595C10.935 0.764278 10.8307 0.525539 10.6526 0.347444C10.4745 0.16935 10.2357 0.0650171 9.98405 0.055296C9.73237 0.0455748 9.48629 0.131181 9.29499 0.295007L5.99999 3.58501L2.70499 0.295007C2.51369 0.131181 2.26762 0.0455748 2.01594 0.055296C1.76426 0.0650171 1.52552 0.16935 1.34743 0.347444C1.16934 0.525539 1.065 0.764278 1.05528 1.01595C1.04556 1.26763 1.13117 1.51371 1.29499 1.70501L4.58499 5.00001L1.29499 8.29501C1.19031 8.38466 1.10529 8.49497 1.04527 8.61904C0.985244 8.7431 0.951515 8.87824 0.946195 9.01596C0.940876 9.15367 0.964081 9.29101 1.01436 9.41933C1.06463 9.54766 1.14089 9.6642 1.23834 9.76166C1.3358 9.85911 1.45235 9.93537 1.58067 9.98565C1.709 10.0359 1.84633 10.0591 1.98405 10.0538C2.12177 10.0485 2.2569 10.0148 2.38096 9.95473C2.50503 9.89471 2.61535 9.80969 2.70499 9.70501L5.99999 6.41501L9.29499 9.70501C9.48629 9.86884 9.73237 9.95444 9.98405 9.94472C10.2357 9.935 10.4745 9.83067 10.6526 9.65257C10.8307 9.47448 10.935 9.23574 10.9447 8.98406C10.9544 8.73239 10.8688 8.48631 10.705 8.29501L7.41499 5.00001Z"
            fill="white"
            fillOpacity="0.8"
          />
        </svg>
      </button>

      <div
        id="nwtakPlayerVOD"
        suppressHydrationWarning
        style={{
          display: "block",
          position: "relative",
          margin: "1rem auto",
          width: "100%",
          height: "auto",
          backgroundColor: "black",
        }}
      />
      
  
    </div>
  );
};

export default VodITGT;